import {CALL_API} from '../../middleware/api';

// 完成任务
export const TASK_COMPLETE_REQUEST = 'TASK_COMPLETE_REQUEST';
export const TASK_COMPLETE_SUCCESS = 'TASK_COMPLETE_SUCCESS';
export const TASK_COMPLETE_FAILURE = 'TASK_COMPLETE_FAILURE';

export function complete(params) {
	return {
		[CALL_API]: {
			types: [TASK_COMPLETE_REQUEST, TASK_COMPLETE_SUCCESS, TASK_COMPLETE_FAILURE],
			endpoint: '/workflow/task/complete',
			methods: 'POST',
			params
		}
};
}

export default (params) => {
	return (dispatch, getState) => {
		return dispatch(complete(params));
	};
};


// WEBPACK FOOTER //
// ./src/action/workflow/complete.js